<app-item-base [open]="open">
  <p class="name" placement="right">
    年齢
  </p>
  <div class="edit-field">
    <input class="" type="text" placeholder="歳" [(ngModel)]="this.searchParams.age_from" name="age_from" />
    <span class="edit-field">&nbsp;&#12316;&nbsp;</span>
    <input class="" type="text" placeholder="歳" [(ngModel)]="this.searchParams.age_to" name="age_to" />
  </div>

  <input class="edit-field" type="checkbox" placement="right"
    [checked]="!this.searchParams.age_null" (change)="this.searchParams.age_null = !this.searchParams.age_null" />
</app-item-base>